import ServiceLocator from "../services/service-locator";

export default class CoachesModal {
    constructor() {
        this.$root = document.getElementById('heroCoaches');
        this.$triggers = this.$root.querySelectorAll('.hero-coach');
        this.$modal = document.getElementById('modal-coaches');
        this.$modalContentItems = this.$modal.querySelectorAll('.coaches-modal-content');
        this.$prev = document.getElementById('coachesModalPrev');
        this.$next = document.getElementById('coachesModalNext');

        this.sl = ServiceLocator.instance;
        this.activeIndex = 0;

        this.init();
    }

    init() {
        this.sl.modalService.register('coaches', Array.from(this.$triggers), {
            beforeOpen: ($trigger) => {
                this.setActive($trigger.dataset.id);
            }
        });

        this.$prev.addEventListener('click', () => {
            const prevId = this.getPrevId();
            this.setActive(prevId);
        });

        this.$next.addEventListener('click', () => {
            const nextId = this.getNextId();
            this.setActive(nextId);
        });
    }

    getPrevId() {
        const prevIndex = this.activeIndex <= 0 ? this.activeIndex : this.activeIndex - 1;
        return this.$modalContentItems[prevIndex].dataset.id;
    }

    getNextId() {
        const nextIndex = this.activeIndex >= this.$modalContentItems.length - 1 ? this.activeIndex : this.activeIndex + 1;
        return this.$modalContentItems[nextIndex].dataset.id;
    }

    getItemIndexById(id) {
        return Array.from(this.$modalContentItems).findIndex($item => $item.dataset.id === id);
    }

    setActive(id) {
        this.activeIndex = this.getItemIndexById(id);
        this.$modalContentItems.forEach($item => $item.classList.remove('-show'));
        this.$modalContentItems[this.activeIndex].classList.add('-show');

        this.$prev.classList.toggle('-disabled', this.activeIndex === 0);
        this.$next.classList.toggle('-disabled', this.activeIndex === this.$modalContentItems.length - 1);
    }
}